import _Vue from 'vue'
import DateHelper from '@/lib/DateHelper'

export default {
  install: function (Vue: typeof _Vue): void {
    Vue.prototype.$dateFormat = (date: string) => {
      return DateHelper.formatDate(date, Vue.prototype.$env.LOCALE_DATE_FORMAT)
    }

    Vue.prototype.$dateFormatWithTime = (date: string) => {
      return DateHelper.formatDate(date, Vue.prototype.$env.LOCALE_DATE_FORMAT+' HH:mm')
    }
  },
}
